export const operandType = (operand, inputs) => {
    
    if (operand === null) {
        return "none"
    } else if (operand.startsWith("inputcheck_")) {
        return "inputcheck"
    } else if (operand.startsWith("input_")) {
        var input = inputs.find(x => x.guid === operand.replace("input_", ""))

        if (!input) return "unknown"

        switch (input.type.toLowerCase()) {
            case "checkbox":
                return "true/false"
            case "text":
            case "textarea":
                return "text"
            case "number":
                return "number";
            default:
            return input.type.toLowerCase()
        }
    }

    return "unknown"
}

export const computeCondition = (condition, inputValues, inputs, processedInputCheckResultsMap) => {
    if (!condition || !condition.operand1) return true;

    const toBoolean = (val) => {
        return val === true || (typeof val === 'string' && val.toLowerCase() === 'true');
    };

    if (condition?.operand1?.startsWith('inputcheck_')) {
        if (
            !(processedInputCheckResultsMap instanceof Map) ||
            !condition?.operand1
        ) {
            return true;
        }
        const calculatedValue = processedInputCheckResultsMap.get(condition.operand1.replace('inputcheck_', ''))
        return calculatedValue?.toLowerCase() === condition?.operand2?.toLowerCase()
    } else if (condition?.operand1?.startsWith('input_')) {
        const operand1Value = inputValues.find(x => x.inputGuid === condition.operand1.replace('input_', ''))?.value
        let operand2Value;
        
        if (condition?.operand2?.startsWith('input_')) {
            operand2Value = inputValues.find(x => x.inputGuid === condition.operand2.replace('input_', ''))?.value
        } else {
            operand2Value = condition.operand2
        }

        if (operandType(condition.operand1, inputs) === "number") {
            switch (condition.comparison) {
                case "Is Equal To":
                    return Number(operand1Value) === Number(operand2Value)
                case "Is Not Equal To":
                    return Number(operand1Value) !== Number(operand2Value)
                case "Is Less Than":
                    return Number(operand1Value) < Number(operand2Value)
                case "Is Greater Than":
                    return Number(operand1Value) > Number(operand2Value)
                case "Is Less Than or Equal To":
                    return Number(operand1Value) <= Number(operand2Value)
                case "Is Greater Than or Equal To":
                    return Number(operand1Value) >= Number(operand2Value)
                default:
                    return true;
            }
        } else if (operandType(condition.operand1, inputs) === "true/false") {
            switch (condition.comparison) {
                case "Is Equal To":
                    return toBoolean(operand1Value) === toBoolean(operand2Value)
                case "Is Not Equal To":
                    return toBoolean(operand1Value) !== toBoolean(operand2Value)
                default:
                    return true;
            }
        } else {
            switch (condition.comparison) {
                case "Is Equal To":
                    return operand1Value === operand2Value
                case "Is Not Equal To":
                    return operand1Value !== operand2Value
                default:
                    return true;
            }
        }
    }
}

